import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_empty_applied.svg'


const _withScopeId = n => (_pushScopeId("data-v-38e80032"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title_text" }, "応募中の求人", -1))
const _hoisted_3 = { class: "home_title_count" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "job_active_empty_img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "job_active_empty_text" }, "応募中の求人はありません", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "job_active_empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "job_active_empty_text" }, "応募中の求人はありません", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "home_layout_card"
}

import ApplyOrderCard from '@/components/ApplyOrderCard.vue';
import Loading from '@/components/Loading.vue';
import { computed, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

type Card = {
  orderId: number;
  shintyokuStatusBadgeName: string;
  empTypeName: string;
  ocupctgName: string;
  companyName: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyOrders',
  props: {
  limit: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const isLoading = ref(false);

const store = useStore();



const limitedCards = computed(() => {
  const cards = store.getters['applyOrder/orders'] as Array<Card>;
  if (props.limit) {
    return cards.slice(0, props.limit);
  }
  return cards;
});

const total = computed(() => {
  return store.getters['applyOrder/total'];
});

const route = useRoute();
// total0件時にパスで判定
const isCurrentPathHome = computed(() => {
  return route.path === '/home/';
});

onBeforeMount(async () => {
  isLoading.value = true;
  await store.dispatch('applyOrder/receive');
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(total)) + "件", 1)
    ]),
    (!_unref(isCurrentPathHome) && _unref(total) === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
      : _createCommentVNode("", true),
    (_unref(isCurrentPathHome) && _unref(total) === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    (_unref(total) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(limitedCards), (card) => {
            return (_openBlock(), _createBlock(ApplyOrderCard, {
              key: card.orderId,
              card: card
            }, null, 8, ["card"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ]))
}
}

})